import { useQuery } from '@tanstack/react-query';
import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services/ApiClient';
import { PickingApiAdapter } from '../adapters/PickingApiAdapter';

export const pickingOrdersQueryKey = (preparationId: number) => ['picking-orders', preparationId] as const;

export const usePickingOrders = (preparationId: number, enabled: boolean) => {
  const httpClient = createHttpClient(apiClientWH);
  const adapter = new PickingApiAdapter(httpClient);

  return useQuery({
    queryKey: pickingOrdersQueryKey(preparationId),
    queryFn: () => adapter.getPickingOrders(preparationId),
    enabled: enabled && preparationId > 0,
    staleTime: 30 * 1000,
  });
};
